import { useState, useEffect } from 'react';
import { Card, Container, Row, Col, Badge } from 'react-bootstrap';
import { getToken, getUser } from '../../../services/login.services';
import { useNavigate } from 'react-router-dom';
import Layout from '../Dashbaord/Layout.js/Layout';
import 'react-toastify/dist/ReactToastify.css';
import '../../../css/dashboard.css';
import { colors } from '../../../utils/Colors';
import UserService from '../../../services/user.services';
import { bookingService } from '../../../services/booking.services';
import { getAllSimpleNewCounts } from '../../../services/bills.services';
const Dashboard = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [user, setUser] = useState(null);
  const [count , setCount] = useState(0)
  const [totalBills , setTotalBills] = useState(0)
  const [newBookingCount , setNewBookingCount] = useState(0)
  const getCounts = async()=>{
    const res = await UserService.getTotalSimpleCounts()

    setCount(res.totalUsers.count)
  }

  const TotalBills = async() =>{
    const res = await getAllSimpleNewCounts()

    setTotalBills(res.data?.count)
  }

  const GetNewBooking = async()=>{
    const res = await bookingService.getNewBookingsCount()

    setNewBookingCount(res.count)
  }
  useEffect(() => {
    const storedToken = getToken();
    const storedUser = getUser();
    getCounts()
    TotalBills()
    GetNewBooking()
    if (storedToken) {
      setToken(storedToken);
    } else {
      navigate('/admin/login');
    }
    
    if (storedUser) {
      setUser(storedUser);
    }
  }, [navigate]);

  return (
    <Layout>
      <Container fluid>
        
        
        
        <Row>
         
          <Col lg={8}>
            <Card className="mb-4 shadow-sm border-0">
              <Card.Header className="text-white" style={{ backgroundColor : colors.TABLE_HEADERS}}>
                <h5 className="mb-0">Quick Stats</h5>
              </Card.Header>
              <Card.Body className="p-3">
                <Row>
                  
                  <Col md={4} className="mb-3">
                    <Card 
                      className="text-center pressable-card h-100" 
                      style={{ 
                        background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                        border: 'none',
                        borderRadius: '10px',
                        cursor: 'pointer'
                      }}
                      onClick={() => navigate('/admin/dashboard/all-user')}
                    >
                      <Card.Body className="p-4">
                        <div className="position-absolute top-0 end-0 p-3">
                          <i className="fas fa-users text-primary opacity-75 fa-lg"></i>
                        </div>
                        <h2 className="text-primary fw-bold mb-2" style={{ fontSize: '2.5rem' }}>{count}</h2>
                        <p className="text-dark mb-0 fw-medium">Total Users</p>
                        <div className="mt-3">
                          <small className="text-muted">
                            <i className="fas fa-arrow-up text-success me-1"></i>
                            12% increase
                          </small>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  
                  
                  <Col md={4} className="mb-3">
                    <Card 
                      className="text-center pressable-card h-100" 
                      style={{ 
                        background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
                        border: 'none',
                        borderRadius: '10px',
                        cursor: 'pointer'
                      }}
                      onClick={() => navigate('/admin/dashboard/bookings')}
                    >
                      <Card.Body className="p-4">
                        <div className="position-absolute top-0 end-0 p-3">
                          <i className="fas fa-calendar-check text-success opacity-75 fa-lg"></i>
                        </div>
                        <h2 className="text-success fw-bold mb-2" style={{ fontSize: '2.5rem' }}>{newBookingCount}</h2>
                        <p className="text-dark mb-0 fw-medium">New Bookings</p>
                        <div className="mt-3">
                          <small className="text-muted">
                            <i className="fas fa-clock text-warning me-1"></i>
                            {newBookingCount} pending
                          </small>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  
                 
                  <Col md={4} className="mb-3">
                    <Card 
                      className="text-center pressable-card h-100" 
                      style={{ 
                        background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
                        border: 'none',
                        borderRadius: '10px',
                        cursor: 'pointer'
                      }}
                      onClick={() => navigate('/admin/dashboard/bills-list')}
                    >
                      <Card.Body className="p-4">
                        <div className="position-absolute top-0 end-0 p-3">
                          <i className="fas fa-file-invoice-dollar text-warning opacity-75 fa-lg"></i>
                        </div>
                        <h2 className="text-warning fw-bold mb-2" style={{ fontSize: '2.5rem' }}>{totalBills}</h2>
                        <p className="text-dark mb-0 fw-medium">Total Bills</p>
                        <div className="mt-3">
                          <small className="text-muted">
                            <i className="fas fa-exclamation-circle text-danger me-1"></i>
                            Requires attention
                          </small>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

         
          <Col lg={4}>
            <Card className="mb-4 shadow-sm border-0">
              <Card.Header className="text-white" style={{ backgroundColor : colors.TABLE_HEADERS}}>
                <h5 className="mb-0">User Information</h5>
              </Card.Header>
              <Card.Body 
                className="pressable-card"
                style={{ 
                  background: 'linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)',
                  borderRadius: '0 0 10px 10px',
                  cursor: 'pointer'
                }}
                onClick={() => navigate('/admin/profile')}
              >
                {user ? (
                  <div className="text-center">
                    <div className="mb-3">
                      <div className="bg-primary d-inline-flex p-3 rounded-circle">
                        <i className="fas fa-user text-white fa-2x"></i>
                      </div>
                    </div>
                    <div className="mb-3">
                      <h5 className="fw-bold text-dark">{user.name || 'N/A'}</h5>
                      <p className="text-muted mb-2">{user.email || 'N/A'}</p>
                      <Badge bg="primary" className="px-3 py-1">
                        {user.role || 'Admin'}
                      </Badge>
                    </div>
                    <div className="d-flex justify-content-center">
                      <div className="text-center mx-3">
                        <div className="fw-bold text-dark">24</div>
                        <small className="text-muted">Actions</small>
                      </div>
                      <div className="text-center mx-3">
                        <div className="fw-bold text-dark">98%</div>
                        <small className="text-muted">Active</small>
                      </div>
                      <div className="text-center mx-3">
                        <div className="fw-bold text-dark">30</div>
                        <small className="text-muted">Days</small>
                      </div>
                    </div>
                  </div>
                ) : (
                  <p className="text-center mb-0">No user information available</p>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>


        <Row>
          <Col>
            <Card className="shadow-sm border-0">
              <Card.Header className="text-white" style={{backgroundColor : colors.TABLE_HEADERS}}>
                <h5 className="mb-0">Quick Actions</h5>
              </Card.Header>
              <Card.Body className="p-3">
                <Row>
                 
                  <Col md={3} className="mb-3">
                    <Card 
                      className="text-center h-100 pressable-card" 
                      style={{ 
                        background: 'linear-gradient(135deg, #e1f5fe 0%, #b3e5fc 100%)',
                        border: 'none',
                        borderRadius: '10px',
                        cursor: 'pointer'
                      }}
                      onClick={() => navigate('/admin/dashboard/create-user')}
                    >
                      <Card.Body className="p-4 d-flex flex-column justify-content-center">
                        <div className="mb-3">
                          <div className="bg-primary d-inline-flex p-3 rounded-circle">
                            <i className="fas fa-user-plus fa-2x text-white"></i>
                          </div>
                        </div>
                        <h6 className="fw-bold text-dark mb-2">Create User</h6>
                        <p className="text-muted small mb-0">Add new user to the system</p>
                        <div className="mt-3 text-primary">
                          <i className="fas fa-chevron-right"></i>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  
                 
                  <Col md={3} className="mb-3">
                    <Card 
                      className="text-center h-100 pressable-card"
                      style={{ 
                        background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
                        border: 'none',
                        borderRadius: '10px',
                        cursor: 'pointer'
                      }}
                      onClick={() => navigate('/admin/dashboard/create-bill')}
                    >
                      <Card.Body className="p-4 d-flex flex-column justify-content-center">
                        <div className="mb-3">
                          <div className="bg-success d-inline-flex p-3 rounded-circle">
                            <i className="fas fa-file-invoice-dollar fa-2x text-white"></i>
                          </div>
                        </div>
                        <h6 className="fw-bold text-dark mb-2">Create Bill</h6>
                        <p className="text-muted small mb-0">Generate new invoice</p>
                        <div className="mt-3 text-success">
                          <i className="fas fa-chevron-right"></i>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  
                  
                  <Col md={3} className="mb-3">
                    <Card 
                      className="text-center h-100 pressable-card"
                      style={{ 
                        background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
                        border: 'none',
                        borderRadius: '10px',
                        cursor: 'pointer'
                      }}
                      onClick={() => navigate('/admin/dashboard/bookings')}
                    >
                      <Card.Body className="p-4 d-flex flex-column justify-content-center">
                        <div className="mb-3">
                          <div className="bg-warning d-inline-flex p-3 rounded-circle">
                            <i className="fas fa-calendar-check fa-2x text-white"></i>
                          </div>
                        </div>
                        <h6 className="fw-bold text-dark mb-2">View Bookings</h6>
                        <p className="text-muted small mb-0">Check all reservations</p>
                        <div className="mt-3 text-warning">
                          <i className="fas fa-chevron-right"></i>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  
                  
                  <Col md={3} className="mb-3">
                    <Card 
                      className="text-center h-100 pressable-card"
                      style={{ 
                        background: 'linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)',
                        border: 'none',
                        borderRadius: '10px',
                        cursor: 'pointer'
                      }}
                      onClick={() => navigate('/admin/dashboard/all-user')}
                    >
                      <Card.Body className="p-4 d-flex flex-column justify-content-center">
                        <div className="mb-3">
                          <div className="bg-purple d-inline-flex p-3 rounded-circle" style={{ backgroundColor: '#9c27b0' }}>
                            <i className="fas fa-chart-bar fa-2x text-white"></i>
                          </div>
                        </div>
                        <h6 className="fw-bold text-dark mb-2">View Reports</h6>
                        <p className="text-muted small mb-0">Analytics & insights</p>
                        <div className="mt-3" style={{ color: '#9c27b0' }}>
                          <i className="fas fa-chevron-right"></i>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default Dashboard;